var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _c(
        "div",
        {
          staticClass: "text-xs-center",
          attrs: { "offset-sm4": "", id: "tour" }
        },
        [
          _c("v-tour", {
            attrs: {
              name: "myTour",
              steps: _vm.steps,
              callbacks: _vm.myCallbacks
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(tour) {
                  return [
                    _c(
                      "transition",
                      { attrs: { name: "fade" } },
                      _vm._l(tour.steps, function(step, index) {
                        return tour.currentStep === index
                          ? _c(
                              "v-step",
                              {
                                key: index,
                                attrs: {
                                  step: step,
                                  "previous-step": tour.previousStep,
                                  "next-step": tour.nextStep,
                                  stop: tour.stop,
                                  "is-first": tour.isFirst,
                                  "is-last": tour.isLast,
                                  labels: tour.labels
                                }
                              },
                              [
                                tour.currentStep === 2
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "actions" },
                                          slot: "actions"
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                type: "button",
                                                large: "",
                                                depressed: "",
                                                color: "primary"
                                              },
                                              on: { click: tour.nextStep }
                                            },
                                            [_vm._v("Yes")]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                type: "button",
                                                large: "",
                                                depressed: "",
                                                color: "primary"
                                              },
                                              on: { click: tour.stop }
                                            },
                                            [_vm._v("No")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e(),
                                _vm._v(" "),
                                tour.currentStep === 3
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "actions" },
                                          slot: "actions"
                                        },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                type: "button",
                                                depressed: "",
                                                color: "primary"
                                              },
                                              on: { click: tour.stop }
                                            },
                                            [_vm._v("Close")]
                                          )
                                        ],
                                        1
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            )
                          : _vm._e()
                      })
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c("v-flex", { attrs: { xs12: "", sm6: "", "offset-sm3": "" } }, [
            _c("h2", { staticClass: "title" }, [
              _vm._v("\n          Art Info\n        ")
            ])
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { row: "" } },
        [
          _c("v-flex", { attrs: { xs12: "" } }, [
            _c(
              "form",
              [
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", "offset-sm3": "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            name: "artistName",
                            label: "Artist Name",
                            id: "artist-name",
                            required: ""
                          },
                          model: {
                            value: _vm.artistName,
                            callback: function($$v) {
                              _vm.artistName = $$v
                            },
                            expression: "artistName"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", "offset-sm3": "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            name: "artTitle",
                            label: "Art Title",
                            id: "art-title",
                            required: ""
                          },
                          model: {
                            value: _vm.artTitle,
                            callback: function($$v) {
                              _vm.artTitle = $$v
                            },
                            expression: "artTitle"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", "offset-sm3": "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            "multi-line": "",
                            name: "description",
                            id: "art-description",
                            label:
                              "Please provide a description about the piece ",
                            rules: [
                              function(v) {
                                return v.length <= 120 || "Max 120 characters"
                              }
                            ],
                            counter: 120,
                            required: ""
                          },
                          model: {
                            value: _vm.description,
                            callback: function($$v) {
                              _vm.description = $$v
                            },
                            expression: "description"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c("v-flex", {
                      attrs: { xs12: "", sm6: "", "offset-sm3": "" }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", "offset-sm3": "" } },
                      [
                        _c(
                          "v-card",
                          { attrs: { id: "selectbox" } },
                          [
                            _c(
                              "v-container",
                              { attrs: { fluid: "" } },
                              [
                                _c(
                                  "v-layout",
                                  { attrs: { "align-center": "", wrap: "" } },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        items: _vm.items,
                                        attach: "",
                                        chips: "",
                                        name: "categories",
                                        id: "categories",
                                        label: "categories",
                                        required: "",
                                        multiple: ""
                                      },
                                      model: {
                                        value: _vm.categories,
                                        callback: function($$v) {
                                          _vm.categories = $$v
                                        },
                                        expression: "categories"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", "offset-sm3": "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: { depressed: "", dark: "", color: "black" },
                            on: { click: _vm.goBack }
                          },
                          [_vm._v("Back")]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              depressed: "",
                              color: "primary",
                              disabled: !_vm.formIsValid
                            },
                            on: { click: _vm.onSubmit }
                          },
                          [_vm._v("Submit")]
                        ),
                        _vm._v(" "),
                        _c("v-layout", [
                          _c(
                            "div",
                            {
                              staticClass: "text-xs-center",
                              attrs: { "offset-sm4": "", id: "tour" }
                            },
                            [
                              _c("v-tour", {
                                attrs: {
                                  name: "myTour",
                                  steps: _vm.steps,
                                  callbacks: _vm.myCallbacks
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "default",
                                    fn: function(tour) {
                                      return [
                                        _c(
                                          "transition",
                                          { attrs: { name: "fade" } },
                                          _vm._l(tour.steps, function(
                                            step,
                                            index
                                          ) {
                                            return tour.currentStep === index
                                              ? _c(
                                                  "v-step",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      step: step,
                                                      "previous-step":
                                                        tour.previousStep,
                                                      "next-step":
                                                        tour.nextStep,
                                                      stop: tour.stop,
                                                      "is-first": tour.isFirst,
                                                      "is-last": tour.isLast,
                                                      labels: tour.labels
                                                    }
                                                  },
                                                  [
                                                    tour.currentStep === 0
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "actions"
                                                              },
                                                              slot: "actions"
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    type:
                                                                      "button",
                                                                    large: "",
                                                                    depressed:
                                                                      "",
                                                                    color:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      tour.nextStep
                                                                  }
                                                                },
                                                                [_vm._v("Yes")]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    type:
                                                                      "button",
                                                                    large: "",
                                                                    depressed:
                                                                      "",
                                                                    color:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      tour.stop
                                                                  }
                                                                },
                                                                [_vm._v("No")]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      : _vm._e(),
                                                    _vm._v(" "),
                                                    tour.currentStep === 1
                                                      ? [
                                                          _c(
                                                            "div",
                                                            {
                                                              attrs: {
                                                                slot: "actions"
                                                              },
                                                              slot: "actions"
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    type:
                                                                      "button",
                                                                    depressed:
                                                                      "",
                                                                    color:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      tour.stop
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Close"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ]
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              : _vm._e()
                                          })
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-68f33d64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f33d64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/artists/upload_an_image.vue
// module id = null
// module chunks = 